import { Icon, Stack, Text } from '@chakra-ui/react';
import { DocumentIcon } from '@heroicons/react/outline';
import { useTranslations } from 'use-intl';

type Props = unknown;

/**
 * DocumentTableEmpty.
 *
 * @returns {JSX.Element}
 */
export function DocumentTableEmpty(): JSX.Element {
  const i18nDocumentTable = useTranslations('DocumentTable');

  return (
    <Stack layerStyle="emptyState">
      <Icon as={DocumentIcon} boxSize="40px" color="gray.500" />
      <Text>{i18nDocumentTable('NoDocuments')}</Text>
    </Stack>
  );
}

export type DocumentTableEmptyProps = Props;
